import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async uploadFile(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.uploadUrl}/queue`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[uploadFile][Store][Upload file resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[uploadFile][Store][Error occured while uploading file--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },


    async attachMetadataToFile(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.uploadUrl}/metadata`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[attachMetadataToFile][Store][File upload resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[attachMetadataToFile][Store][Error occured while attaching metadata to file--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async uploadCloudOnCompletion(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.uploadUrl}/cloud`, "", { headers: payload.params });
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[uploadCloudOnCompletion][Store][File upload resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }

        } catch (error) {

            console.error(
                `[uploadCloudOnCompletion][Store][Error occured while posting upload to file--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    // async discardFileFromUpload(context, payload = {}) {
    //     //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

    //     try {
    //         let resp = await axios.delete(`${Constants.uploadUrl}/${payload.job_id}/file/${payload.file_uid}`, payload);
    //         if (Constants.acceptedStatusCodes.includes(resp.status)) {
    //             console.log(
    //                 `[discardFileFromUpload][Store][File upload discard resp-->${resp.status}]`
    //             );
    //             resp.data.statusCode = resp.status
    //             return resp.data;
    //         } else {
    //             throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
    //         }
    //     } catch (error) {
    //         console.error(
    //             `[discardFileFromUpload][Store][Error occured while discarding file from upload--->${error}]`
    //         );
    //         if (error.response) {
    //             if (error.response.status == 401) {
    //                 return context.dispatch("users/logOutFromServer", {}, { root: true })
    //             } else {
    //                 error.response.data.statusCode = error.response.status
    //                 return error.response.data
    //             }
    //         }
    //         return {}
    //     }

    // },

    async cancelUploadFile(context, payload = {}) {
        //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

        try {
            let resp = await axios.delete(`${Constants.uploadUrl}/${payload.group_id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[cancelUploadFile][Store][Cancel upload resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[cancelUploadFile][Store][Error occured while discarding file from upload--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async abortMultipartUpload(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.uploadUrl}/multipart/abort-upload`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[abortMultipartUpload][Store][File upload resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }

        } catch (error) {

            console.error(
                `[abortMultipartUpload][Store][Error occured while posting upload to file--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async attachCustomThumbnail(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.uploadUrl}/file/customthumbnail/` + payload.file_uid, payload.data);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[attachCustomThumbnail][Store][Upload file resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[attachCustomThumbnail][Store][Error occured while uploading file--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async attachCustomThumbnailToSoftSubclip(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.singleAssetUrl}/customthumbnail/` + payload.asset_id, payload.data);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[attachCustomThumbnailToSoftSubclip][Store][Upload file resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[attachCustomThumbnailToSoftSubclip][Store][Error occured while attaching thumbnail--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async initiateUploadBySubmittingAction(context, payload) {
        let folderFullPath = "";
        if (Object.keys(payload.folderInfo).includes("path") && payload.folderInfo.path != undefined) {
            folderFullPath = payload.folderInfo.path;
        } else {
            folderFullPath = "share://" + payload.bin_id;
        }
        let payloadData = {};
        payloadData = { path: "path=" + encodeURIComponent(folderFullPath) };
        try {
            let resp = await axios.get(`${Constants.uploadUrl}/request?${payloadData.path}`, payloadData);
            console.log("resprespresp",resp)
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return { "data": resp.data, "status": true };
            } else {
                return { "status": false, "message": resp.data.message }
            }  
        } catch (error) {
            if (Constants.acceptedStatusCodes.includes(error.response.status)) {
                error.response.data.statusCode = error.response.status
                return { "data": error.response.data, "status": true };
            } else {
                return { "status": false, "message": error.response.data.message }
            }  
        }
    },

    async getProxyBinUploadDetails(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.proxyBinUploadUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[uploadFile][Store][Upload file resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                console.log(`Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`);
                throw new Error('Error occured while requesting file upload.');
            }
        } catch (error) {
           console.error(
                `[uploadFile][Store][Error occured while requesting file upload.--->${error}]`
            ); 
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    throw new Error('Error occured while requesting file upload.')
                    // error.response.data.statusCode = error.response.status
                }
            }
           throw new Error('Error occured while requesting file upload.');
        }
    },
    //Added to handle resumable upload
    async getSessionInfoFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.sessionInfoUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getSessionInfoFromServer][Store][Error occured while getting Session info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getCloudSessionInfoFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.uploadUrl}/multipart/previous-upload`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getSessionInfoFromServer][Store][Error occured while getting Session info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async createUploadSession(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.sessionInfoUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[createUploadSession][Store][Error occured while creating folder upload session--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

};